export const NEW = 'new';
export const BETA = 'beta';
export const ALPHA = 'alpha';
